import { isApiAccommodationListError, } from '@data/api/types/accommodation-list';
import { parseRawBoolean } from '@data/api/helpers';
import { parseLegacyRoomsRelation, parseSplitInventory, } from '@business/inventory/parse-inventory';
import Accommodation from './Accommodation';
import UnavailableAccommodation from './UnavailableAccommodation';
import RateCheckerData from './RateCheckerData';
export default class AccommodationList {
    constructor(data, options) {
        var _a, _b, _c;
        Object.defineProperty(this, "bookableLimitEnabled", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "checkin", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "checkout", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "currency_rate", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "items", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        Object.defineProperty(this, "rateCheckerData", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "splitInventory", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        Object.defineProperty(this, "splitRoomRelations", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "unavailableItems", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: []
        });
        if (!!data && isApiAccommodationListError(data)) {
            this.currency_rate = 1;
            this.rateCheckerData = new RateCheckerData();
            return;
        }
        this.currency_rate = (data === null || data === void 0 ? void 0 : data.currency_rate) || 1;
        this.splitRoomRelations = parseLegacyRoomsRelation(data === null || data === void 0 ? void 0 : data.roomsRelation);
        const isUsingNewAmenitiesSystem = (_a = options === null || options === void 0 ? void 0 : options.isUsingNewAmenitiesSystem) !== null && _a !== void 0 ? _a : false;
        this.items =
            ((_b = data === null || data === void 0 ? void 0 : data.room_types) === null || _b === void 0 ? void 0 : _b.map((room) => new Accommodation(room, { isUsingNewAmenitiesSystem }))) || [];
        this.splitInventory = parseSplitInventory(data === null || data === void 0 ? void 0 : data.sharedInventory, data === null || data === void 0 ? void 0 : data.room_types);
        this.rateCheckerData = new RateCheckerData(data === null || data === void 0 ? void 0 : data.ma_rates);
        this.bookableLimitEnabled =
            parseRawBoolean(data === null || data === void 0 ? void 0 : data.bookable_limit_enabled) &&
                !!(data === null || data === void 0 ? void 0 : data.booking_limit_per_person);
        this.unavailableItems =
            ((_c = data === null || data === void 0 ? void 0 : data.unavailable_room_types) === null || _c === void 0 ? void 0 : _c.map((room) => new UnavailableAccommodation(room))) || [];
    }
}
